// In-Memory fallback for Redis (Since Docker/Redis is not running)
const cache = new Map<string, { value: string; expiresAt: number }>();

// Provide a mock redis object so server.ts doesn't crash on .connect() or .quit()
export const redis = {
  connect: async () => console.log('✅ In-memory Cache connected (Redis fallback)'),
  quit: async () => {},
};

// Presence helpers
export const PRESENCE_TTL = 30; // seconds

function cleanCache() {
  const now = Date.now();
  for (const [key, item] of cache.entries()) {
    if (item.expiresAt < now) cache.delete(key);
  }
}

export async function setPresence(userId: string, presence: string): Promise<void> {
  cleanCache();
  cache.set(`presence:${userId}`, {
    value: presence,
    expiresAt: Date.now() + PRESENCE_TTL * 1000,
  });
}

export async function getPresence(userId: string): Promise<string> {
  cleanCache();
  const item = cache.get(`presence:${userId}`);
  if (item && item.expiresAt > Date.now()) return item.value;
  return 'offline';
}

export async function getBulkPresence(userIds: string[]): Promise<Record<string, string>> {
  cleanCache();
  if (!userIds.length) return {};
  
  const now = Date.now();
  return userIds.reduce((acc, id) => {
    const item = cache.get(`presence:${id}`);
    acc[id] = item && item.expiresAt > now ? item.value : 'offline';
    return acc;
  }, {} as Record<string, string>);
}

// Token blacklist
export async function blacklistToken(token: string, ttlSeconds: number): Promise<void> {
  cleanCache();
  cache.set(`blacklist:${token}`, {
    value: '1',
    expiresAt: Date.now() + ttlSeconds * 1000,
  });
}

export async function isTokenBlacklisted(token: string): Promise<boolean> {
  cleanCache();
  const item = cache.get(`blacklist:${token}`);
  return !!(item && item.expiresAt > Date.now());
}
